import React from 'react';
import {Link} from "react-router-dom";
import {Form2FileUpload} from "react-spaceship-web";

export default class Signature extends React.Component {
    constructor(props) {
        super(props);

        let _state = {};
        window.Route.on({
            '/v2/my-signature': () => {
                _state = {
                    mode: 'list',
                    signature: [],
                };
            },
            '/v2/my-signature/new': () => {
                _state = {
                    mode: 'create',
                    signature: [],
                };
            },
            '/v2/my-signature/:signature_id': (params) => {
                _state = {
                    mode: 'view',
                    params: params,
                    signature: [],
                };
            },
            '/v2/my-signature/:signature_id/edit': (params) => {
                _state = {
                    mode: 'edit',
                    params: params,
                    signature: [],
                };
            }
        }).match();

        this.state = _state;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.Route.on({
                '/v2/my-signature': () => {
                    this.setState({
                        mode: 'list',
                        is_table_loading: true,
                    }, () => {
                        this.fetch();
                    })
                },
                '/v2/my-signature/new': () => {
                    this.setState({
                        mode: 'create'
                    })
                },
                '/v2/my-signature/:signature_id': (params) => {
                    this.setState({
                        mode: 'view',
                        params: params,
                        is_table_loading: true,
                    }, () => {
                        this.view();
                    });
                },
                '/v2/my-signature/:signature_id/edit': (params) => {
                    this.setState({
                        mode: 'edit',
                        params: params,
                        is_table_loading: true,
                    }, () => {
                        this.edit();
                    });
                }
            }).match();
        } else if (this.props.location.search !== prevProps.location.search) {
            this.fetch();
        }
    }

    componentDidMount() {
        if (this.state.mode === 'list') {
            this.fetch();
        }
        if (this.state.mode === 'view') {
            this.view();
        }
        if (this.state.mode === 'edit') {
            this.edit();
        }
    }

    edit() {
        let data = {};
        data.signature_id = this.state.params.signature_id;
        window.Global.ajax({
            method: 'GET',
            url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
            data: data,
            done: (response) => {
                this.setState({
                    is_table_loading: false,
                    signature: response.signature[0]
                });
            },
            fail: () => {

            }
        });
    }

    view() {
        let data = {};
        data.signature_id = this.state.params.signature_id;
        window.Global.ajax({
            method: 'GET',
            url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
            data: data,
            done: (response) => {
                this.setState({
                    is_table_loading: false,
                    signature: response.signature[0]
                });
            },
            fail: () => {

            }
        });
    }

    fetch() {
        this.setState({
            is_loading: true,
            signature: [],
        }, () => {
            this.setState({
                is_loading: false,
            })
        });

        let data = window.Global.getAllQueryStrings();

        window.Global.ajax({
            method: 'GET',
            url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
            data: data,
            done: (response) => {
                this.setState({
                    is_loading: false,
                    signature: response.signature
                }, () => {
                    if (response.created_user) {
                        this.$parent.find('form').find('input[name="created_user_id"]').explorer('set value', response.created_user);
                    }

                    this.$parent.find('.Table_root').tablePagination({
                        disableContent: true,
                        data: response.signature,
                        count: response.count,
                        onClickPagination: (p) => {
                            let qs = window.Global.getAllQueryStrings();
                            qs.page = p;
                            this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
                        }
                    });
                });
                // window.Route.setLink();
            },
            fail: () => {

            }
        });
    }

    renderView() {
        return (
            <div ref={(ref) => {
                this.$parent = window.$(ref);
                // Route.setLink();
            }} className="main ui container">
                <div style={{marginBottom: '1rem'}}>
                    <div className="flex row wrap middle-xs">
                        <div className="ui huge breadcrumb">
                            <Link className="section active"
                                  to="/v2/my-signature">
                                ลายเซ็น
                            </Link>
                            <span className="divider" style={{margin: '0px 1rem'}}>/</span>
                            <div
                                className="section">{this.state.signature.title} {this.state.signature.position ? '(' + this.state.signature.position + ')' : null}</div>
                        </div>
                    </div>
                </div>
                <div
                    className={this.state.is_table_loading ? "ui tall stacked loading segment" : "ui tall stacked segment"}>
                    <form className="ui form" autoComplete="off">
                        <div className="flex row middle-xs"
                             style={{padding: '0 0 9px 0'}}>
                            <h2 style={{margin: 0}}>
                                ข้อมูลลายเซ็น
                            </h2>
                            <div className="flex row right floated">
                                <div className="ui basic gray buttons">
                                    {/*<div className="ui button"*/}
                                    {/*     onClick={*/}
                                    {/*	     () => this.printPdf()*/}
                                    {/*     }>*/}
                                    {/*	พิมพ์เอกสาร*/}
                                    {/*</div>*/}
                                    {
                                        this.state.signature.is_void === 0
                                            ?
                                            <>
                                                <Link className="ui button"
                                                      to={"/v2/my-signature/" + this.state.signature.id + '/edit'}>
                                                    แก้ไข
                                                </Link>
                                                <div className="ui button"
                                                     onClick={() => {
                                                         window.Global.confirm({
                                                             title: 'ยกเลิก',
                                                             content: window.Handlebars.compile('<form class="ui form" autocomplete="off">\n\t<p>โปรดยืนยันยกเลิก การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n\t<div class="ui error message"></div>\n</form>')({}),
                                                             cancel_text: 'ไม่ดำเนินการ',
                                                             approve_text: 'ยกเลิกเอกสาร',
                                                             onShowToSetupForm: ($modal) => {
                                                                 $modal.find('form').form2('setup');
                                                                 $modal.find('form').form2('submit', {
                                                                     method: 'DELETE',
                                                                     url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
                                                                     loadingButton: $modal.find('.button'),
                                                                     beforeSent: (data) => {
                                                                         data.signature_id = this.state.signature.id;
                                                                         return data;
                                                                     },
                                                                     onSuccess: (response) => {
                                                                         $modal.modal('hide');
                                                                         window.Global.messageTop({
                                                                             type: 'positive',
                                                                             message: 'ยกเลิกเรียบร้อย'
                                                                         });
                                                                         this.props.history.push({
                                                                             pathname: '/v2/my-signature',
                                                                             state: null,
                                                                         });

                                                                     }
                                                                 });
                                                             }
                                                         });
                                                     }}>
                                                    ยกเลิก
                                                </div>
                                            </>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="ui divider" style={{margin: '0 0 14px 0'}}/>
                        <div className={"flex row wrap padded four column computer"}>
                            <div className="column field">
                                <label>ชื่อ-นามสกุล</label>
                                {this.state.signature.title}
                            </div>
                            <div className="column field">
                                <label>ตำแหน่ง</label>
                                {this.state.signature.position}
                            </div>
                            <div className="column field">
                                <label>ลายเซ็น</label>
                                {
                                    this.state.signature
                                    && this.state.signature.file_upload
                                    && this.state.signature.file_upload.url ?
                                        <img src={this.state.signature.file_upload.url} alt={"SignatureImage"}
                                             style={{maxHeight: 80}}/>
                                        : null
                                }


                            </div>
                        </div>

                    </form>
                </div>
            </div>
        );
    }

    renderList() {
        return (
            <div ref={(ref) => {
                if (!ref) return;
                this.$parent = window.$(ref);
            }}
                 key={'ddd' + window.Global.getRandomInt(1, 99999999)}
                 className="main ui container">
                <div style={{marginBottom: '1rem'}}>
                    <div className="flex row wrap middle-xs">
                        <div className="ui huge breadcrumb">
                            <Link className="section active"
                                  to="/v2/my-signature">
                                ลายเซ็น
                            </Link>
                        </div>

                        <div className="right floated">
                            <Link  to="/v2/settings/documents?type=sale_order_quotation"
                                  className="ui button">ฟอร์มการพิมพ์เอกสาร</Link>
                            <Link id="addSaleOrderButton" to="/v2/my-signature/new"
                                  className="ui positive button">ลายเซ็นใหม่</Link>
                        </div>
                    </div>
                    <div id="Search_root" className="box" style={{display: 'none', marginTop: '1rem'}}
                         ref={(ref) => {
                             let $search = window.$(ref);
                             window.Search.init({
                                 $node: $search,
                                 onSubmit: (data) => {
                                     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
                                     return false;
                                 }
                             });
                             $search.find('input[name="created_user_id"]').explorer({
                                 url: process.env.REACT_APP_DOMAIN + '/api/user',
                                 additionalData: () => {
                                     return {
                                         limit: 10
                                     }
                                 },
                                 key: 'user',
                                 template: {
                                     list: '<a class="item">\n\t<div class="flex row wrap between-xs">\n\t\t<b style="color: darkgreen;">{{name}}</b>\n\t</div>\n</a>',
                                     selected: {
                                         display_template: '{{name}}',
                                         value: 'id',
                                         placeholder: 'ผู้บันทึก'
                                     }
                                 }
                             });
                         }}>
                        <form className="ui form">
                            <div className="flex row wrap padded five column computer">
                                <div className="column field">
                                    <div className="field">
                                        <label>ชื่อนามสกุล</label>
                                        <input type="text" name="title" placeholder="ชื่อนามสกุล"/>
                                    </div>
                                </div>
                                <div className="column field">
                                    <div className="field">
                                        <label>ตำแหน่ง</label>
                                        <input type="text" name="position" placeholder="ตำแหน่ง"/>
                                    </div>
                                </div>
                                <div className="column field">
                                    <div className="field">
                                        <label>ผู้บันทึก</label>
                                        <input type="text" name="created_user_id"/>
                                    </div>
                                </div>
                                <div className="column field">
                                    <div className="field">
                                        <label>สถานะ</label>
                                        <select name="status"
                                                className="ui dropdown fluid"
                                                data-form2_setup="">
                                            <option value="active">ใช้งาน</option>
                                            <option value="void">ยกเลิก</option>
                                            <option value="all">ทั้งหมด</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="column fluid right floated">
                                    <label style={{opacity: 0}}>อื่นๆ</label>
                                    <div className="flex row wrap right floated end-xs">
                                        <button className="ui icon button green"
                                                type="submit">
                                            <i className="search icon"/> ค้นหา
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="flex row wrap padded">
                    <div className="col-xs-16 padded">
                        <div className="ui basic table can click Table_root td-top-xs" style={{marginTop: 0}}>
                            <div className="thead">
                                <div className="tr">
                                    <div className="th span4">ชื่อนามสกุล</div>
                                    <div className="th span3">ตำแหน่ง</div>
                                    <div className="th span3">ลายเซ็น</div>
                                    <div className="th span3">สถานะ</div>
                                    <div className="th span3">ผู้บันทึก</div>
                                </div>
                            </div>
                            <div className="tbody">
                                {
                                    this.state.is_loading
                                        ? <div className="tr">
                                            <div className="td center aligned" data-info="nodata">
                                                <div className="ui active centered inline small loader"/>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    this.state.signature.length === 0
                                    && !this.state.is_loading
                                    && (
                                        !window.Global.getAllQueryStrings().page
                                        || window.Global.getAllQueryStrings().page === '1'
                                    )
                                        ? <div className="tr">
                                            <div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
                                        </div>
                                        : null
                                }
                                {
                                    this.state.signature
                                    && this.state.signature.length > 0 ?
                                        this.state.signature.map((signature, signature_index) => {
                                            return (
                                                <Link className="tr"
                                                      to={signature.url}
                                                      key={signature_index}>
                                                    <div className="td span4">
                                                        <div>{signature.title}</div>
                                                    </div>
                                                    <div className="td span3">
                                                        <div>{signature.position}</div>
                                                    </div>
                                                    <div className="td span3">
                                                        <div>
                                                            {signature.file_upload
                                                            && signature.file_upload.url ?
                                                                <img src={signature.file_upload.url}
                                                                     alt={"Signature"} style={{height: 60}}/>
                                                                : null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="td span3">
                                                        <div>
                                                            {
                                                                signature.is_void === 1
                                                                    ? <div className="ui label red">ยกเลิก</div>
                                                                    : null
                                                            }
                                                            {
                                                                signature.is_void === 0
                                                                    ? <div className="ui label green">ปกติ</div>
                                                                    : null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="td span3">
                                                        <div>
                                                            {signature.created_user.name}
                                                            <br/>
                                                            {window.Global.getDateThai(signature.date_created)}
                                                        </div>
                                                    </div>
                                                </Link>
                                            )
                                        })
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.state.mode === 'list') {
            return this.renderList();
        }
        if (this.state.mode === 'view') {
            return this.renderView();
        }
        if (this.state.mode === 'edit' && !this.state.signature) return (<div/>);
        return (
            <div ref={(ref) => {
                this.$parent = window.$(ref);
                this.$parent.find('form').form2('submit', {
                    method: this.state.mode === 'create' ? 'POST' : 'PUT',
                    url: process.env.REACT_APP_DOMAIN + '/api/v1/signature',
                    beforeSent: (object) => {
                        // console.log(object);

                        if (this.state.mode === 'edit') {
                            object.signature_id = this.state.signature.id;
                            if (this.state.signature.file_upload
                                && this.state.signature.file_upload.filename
                                && (this.state.signature.file_upload.filename === object.signature_filename)) {
                                object.signature_filename = '';
                            }
                        }
                        // console.log(object);
                        return object;
                    },
                    loadingButton: window.$(this.$parent).find('#submit-button'),
                    onSuccess: (response) => {
                        // console.log(response);
                        window.Global.messageTop({
                            type: 'positive',
                            message: 'บันทึกข้อมูลสำเร็จ'
                        });
                        // this.context.router.transitionTo('/v2/settings/documents?type=' + response.document.type);
                        if (this.state.mode === 'create') {
                            window.location = '/v2/my-signature/' + response.signature_id;
                        }
                        if (this.state.mode === 'edit') {
                            window.location = '/v2/my-signature/' + response.signature.id;
                        }

                    }
                });
                // Route.setLink();
            }} className="main ui container">
                <div style={{marginBottom: '1rem'}}>
                    <div className="flex row wrap middle-xs">
                        <div className="ui huge breadcrumb">
                            <Link className="section active"
                                  to={"/v2/my-signature/"}>
                                ลายเซ็น
                            </Link>
                            <span className="divider" style={{margin: '0px 1rem'}}>/</span>
                            {
                                this.state.mode === 'create' ?
                                    <div className="section">ใหม่</div>
                                    : null
                            }
                            {
                                this.state.mode === 'edit'
                                && this.state.signature ?
                                    <>
                                        <Link className="section"
                                              to={"/v2/my-signature/" + this.state.signature.id}>
                                            {this.state.signature.title}
                                        </Link>
                                        <span className="divider" style={{margin: '0px 1rem'}}>/</span>
                                        <div className="active section">แก้ไข</div>
                                    </>
                                    : null
                            }
                        </div>
                    </div>
                </div>
                <form id="Signature_root"
                      className={this.state.mode === 'edit' && this.state.is_table_loading ? "ui form ui tall stacked loading segment" : "ui form ui tall stacked segment"}
                      autoComplete="off">
                    <div className="flex row wrap middle-xs Signature_head" style={{padding: '2px 0 14px 0'}}>
                        <h2 style={{margin: 0}}>
                            {this.state.mode === 'edit' ? 'แก้ไข' : null}
                            ลายเซ็น
                            {this.state.mode === 'create' ? 'ใหม่' : null}

                        </h2>
                    </div>
                    <div className="ui divider" style={{margin: '0 0 14px 0'}}/>
                    <div className={"flex row wrap padded four column computer"}>
                        <div className="column field">
                            <label>ชื่อ-นามสกุล</label>
                            <input name={"title"}
                                   defaultValue={this.state.signature && this.state.signature.title ? this.state.signature.title : ''}/>
                        </div>
                        <div className="column field">
                            <label>ตำแหน่ง</label>
                            <input name={"position"}
                                   defaultValue={this.state.signature && this.state.signature.position ? this.state.signature.position : ''}/>
                        </div>
                        <div className="column field">
                            <label>ลายเซ็น</label>
                            <Form2FileUpload
                                upload_type="single_image"
                                input_name="signature_filename"
                                removeInputName="signature_filename"
                                isCanRemove={true}
                                value={this.state.signature && this.state.signature.file_upload ? this.state.signature.file_upload.filename : ''}
                                image_url={this.state.signature && this.state.signature.file_upload ? this.state.signature.file_upload.url : ''}
                                key_file_data="file_upload"
                                width="400px"
                                height="150px"
                                mode={"view"}
                                url={process.env.REACT_APP_DOMAIN + "/api/file/upload?type=upload"}
                                // onRemove={this.state.signature && this.state.signature.file_upload ? () => {
                                // 	return false;
                                // } : false}
                                onUploadDone={(file) => {
                                    // console.log(file);
                                    return true;
                                }}
                            />
                        </div>
                    </div>
                    <div className="ui error message"/>
                    <div className="flex row" style={{marginTop: '1rem'}}>
                        <Link
                            to={this.state.mode === 'edit' && this.state.signature && this.state.signature.id ? '/v2/my-signature/' + this.state.signature.id : '/v2/my-signature/'}
                            className={"ui button"}>ยกเลิก</Link>
                        <div className="right floated">
                            <button id="submitButton" className="ui positive button" type="submit">
                                {this.state.mode === 'create' ? 'เพิ่มลายเซ็น' : null}
                                {this.state.mode === 'edit' ? 'แก้ไข' : null}
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        );
    }
}
